module.exports = __webpack_public_path__ + "static/sample offer letter-ccd23cd26a548e02da284f900efe9a25.png";